import React, { Component } from 'react';
import { TacticalLabel } from './TacticalLabel';
import { TopoPattern } from './TopoPattern';
import { ThermometerSnowflake, Fan, Wrench, AlertTriangle, Settings, Zap } from 'lucide-react';
const services = [{
  code: 'OP-01',
  title: 'AC INSTALLATION & REPLACEMENT',
  desc: 'Full system changeouts. Manual J sized for exact cooling loads.',
  icon: ThermometerSnowflake
}, {
  code: 'OP-02',
  title: 'MINI-SPLIT SYSTEMS',
  desc: 'Daikin, Mitsubishi, Aurus. Zoned cooling for additions and garages.',
  icon: Fan
}, {
  code: 'OP-03',
  title: 'HEAT PUMP INSTALLATION',
  desc: 'High-efficiency electric heating and cooling. Rebate eligible.',
  icon: Zap
}, {
  code: 'OP-04',
  title: 'EMERGENCY REPAIR',
  desc: 'Rapid deployment for AC not cooling. 24/7 dispatch available.',
  icon: AlertTriangle
}, {
  code: 'OP-05',
  title: 'MOTOR & COMPRESSOR',
  desc: 'Component-level diagnostics and replacement. No unnecessary upsells.',
  icon: Wrench
}, {
  code: 'OP-06',
  title: 'PACKAGE & SPLIT SYSTEMS',
  desc: 'Rooftop and ground-mount solutions built for the desert.',
  icon: Settings
}];
export function Capabilities() {
  return <section id="services" className="py-24 bg-sapper-dark relative" data-id="element-8">
      <TopoPattern opacity={0.03} className="text-sapper-white" data-id="element-9" />

      <div className="container mx-auto px-4 sm:px-6 relative z-10" data-id="element-10">
        <div className="mb-16 max-w-3xl" data-id="element-11">
          <TacticalLabel className="mb-4" data-id="element-12">
            SECTION 02 // CAPABILITIES
          </TacticalLabel>
          <h2 className="font-condensed font-bold text-5xl sm:text-6xl text-sapper-white uppercase tracking-tight mb-6" data-id="element-13">
            WHAT WE DEPLOY ON
          </h2>
          <p className="font-sans text-lg text-sapper-gray max-w-2xl" data-id="element-14">
            Built for Arizona homes. Every install Manual J sized, every system
            pressure tested, every job done right the first time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-15">
          {services.map(service => <div key={service.code} className="bg-sapper-olive/20 border-t-2 border-t-sapper-red border-x border-b border-sapper-olive/30 p-8 relative group hover:bg-sapper-olive/30 transition-colors" data-id="element-16">
              <div className="absolute top-4 right-4 font-mono text-xs text-sapper-gray font-bold tracking-widest" data-id="element-17">
                {service.code}
              </div>

              <service.icon className="w-10 h-10 text-sapper-white mb-6 group-hover:text-sapper-red transition-colors" strokeWidth={1.5} data-id="element-18" />

              <h3 className="font-condensed font-bold text-2xl text-sapper-white uppercase tracking-wide mb-3" data-id="element-19">
                {service.title}
              </h3>

              <p className="font-sans text-sapper-gray text-sm mb-8 min-h-[40px]" data-id="element-20">
                {service.desc}
              </p>

              <a href="#contact" className="inline-flex items-center font-mono text-xs text-sapper-red font-bold tracking-widest hover:text-white transition-colors" data-id="element-21">
                &gt; VIEW DETAILS
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}